<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-else>
                <div class="col-md-4">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code"><label style="color: red; height: 2px;" >*</label>
                            شماره کارت</label>
                        <div class="input-group">
                            <input required type="text" class="form-control text-center" v-model="pan" v-mask="'####-####-####-####'">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
                <div class="col-md-12 mt-4"  >
                    <div class="row">
                        <h6 class="px-3" >
                            موجودی : 
                        </h6>
                        <h6 v-if="this.result" >  {{ this.result }} ریال 
                        </h6>
                        <h6 v-else >-</h6>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardsBalance',
    data(){
        return {
            pan:"",
            result:"",
            showLoading: false
        }
    },
    methods: {
        searchCustomer(){
            this.showLoading = true;
            this.$api.get('cards/getbalance?pan=' + this.pan.replace(/-/g,'')).then(({data}) => {
                if(data.status){
                    this.result = data.result.totalAmount;
                }
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
     
    },
}
</script>
